import { useState } from "react";
import AuthDialog from "../auth/AuthDialog";
import { HealthyLife, StartFreeTrail } from "../discovery/LandingPage";
import { Icon } from "@iconify/react";
import useIsMobile from "../../utils/useIsMobile";
import bg_about_us from "../../assets/images/bg_about_us.png";
import { useNavigate } from "react-router-dom";

export default function AboutUsPage() {
  const [showAuth, setShowAuth] = useState(false);
  const [selectedSection, setSelectedSection] = useState("our-story");
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  return (
    <div className="w-full h-full bg-primary-midBlack">
      <AuthDialog open={showAuth} setOpen={setShowAuth} />
      <div
        style={{
          backgroundImage: `url(${bg_about_us})`,
        }}
        className=" w-full py-10 snap-mandatory bg-center bg-no-repeat bg-cover snap-y overflow-auto no-scrollbar"
      >
        {/* <a href="/">
          <p className="text-white font-bold flex flex-row items-center gap-1 px-5 md:px-32 mb-10">
            <span>
              <Icon icon="ic:baseline-arrow-right-alt" className="rotate-180" />
            </span>
            Go back to the home page
          </p>
        </a> */}
        <p>
          <p
            className="text-white font-bold flex flex-row items-center gap-1 px-5 md:px-32 mb-10"
            onClick={() => {
              navigate("/");
            }}
          >
            <span>
              <Icon icon="ic:baseline-arrow-right-alt" className="rotate-180" />
            </span>
            Go back to the home page
          </p>
        </p>
        <div className=" flex flex-row relative md:h-screen ">
          {!isMobile && (
            <div className="flex flex-col gap-10 sticky top-0 px-5 md:px-32">
              <p
                onClick={() => {
                  setSelectedSection("our-story");
                }}
                className={`${
                  selectedSection == "our-story"
                    ? "text-opacity-100"
                    : "text-opacity-10"
                } font-poppins cursor-pointer text-white font-bold text-3xl md:text-4xl leading-snug `}
              >
                Our<br></br>
                <span
                  className={`${
                    selectedSection == "our-story"
                      ? "text-primary-neonGreen"
                      : ""
                  }`}
                >
                  Story
                </span>
              </p>

              <p
                onClick={() => {
                  setSelectedSection("founder-story");
                }}
                className={`${
                  selectedSection == "founder-story"
                    ? "text-opacity-100"
                    : "text-opacity-10"
                } font-poppins cursor-pointer text-white font-bold text-3xl md:text-4xl leading-snug `}
              >
                Founder's<br></br>
                <span
                  className={`${
                    selectedSection == "founder-story"
                      ? "text-primary-neonGreen"
                      : ""
                  }`}
                >
                  Story
                </span>
              </p>
              <p
                onClick={() => {
                  setSelectedSection("our-team");
                }}
                className={`${
                  selectedSection == "our-team"
                    ? "text-opacity-100"
                    : "text-opacity-10"
                } font-poppins cursor-pointer text-white font-bold text-3xl md:text-4xl leading-snug `}
              >
                Our<br></br>
                <span
                  className={`${
                    selectedSection == "our-team"
                      ? "text-primary-neonGreen"
                      : ""
                  }`}
                >
                  Team
                </span>
              </p>
            </div>
          )}
          <div className="font-open-sans flex flex-1 flex-col md:h-screen md:overflow-scroll text-white text-opacity-80 leading-8 no-scrollbar pl-5 md:pl-0 pr-5 md:pr-64">
            {(selectedSection == "our-story" || isMobile) && (
              <div>
                {isMobile && (
                  <p
                    className={`font-poppins cursor-pointer text-white font-bold text-4xl md:text-4xl leading-snug `}
                  >
                    Our <span className="text-primary-neonGreen">Story</span>
                  </p>
                )}
                <p>
                  The pandemic gave us{" "}
                  <span className="font-bold">
                    tough times and great learnings
                  </span>
                  . It made us realize that ignorance is not always a bliss. We
                  realized what it means to have a humane bond and the power of
                  gratitude.
                  <br /> And if we relook at those couple of years, one thing
                  that becomes a hard fact is that{" "}
                  <span className="font-bold">
                    health{" "}
                    <span className="text-primary-neonGreen">REALLY</span>{" "}
                    matters
                  </span>
                  . And no one can escape it. <br />
                  And during those cushioned times of stay-at-home, most of us
                  put on some extra pounds. Thanks to those non-stop munching
                  during e-meets, the always-on power naps, and doing everything
                  from the bed. Read More
                </p>
                <br />
                <p className="font-bold">
                  Because assistant-led services are what people are looking
                  for, why not personalized health and fitness?{" "}
                  <span className="text-primary-neonGreen">
                    Why not build an OTT
                  </span>{" "}
                  (an online Tech trainer) that enables you to be a healthier
                  you? We pivoted our physical first model from the Covid times
                  to this
                  {"  "}
                  <span className="text-primary-neonGreen">
                    tech-enabled
                  </span>{" "}
                  model
                </p>
                <br />
                <p>
                  Our guided{" "}
                  <span className="font-bold">Motion Tracking Technology</span>{" "}
                  tracks every move of your body, converts your device
                  (laptop/mobile) camera into your personal coach, and provides
                  a synchronous experience by correcting postures and forms
                  along with relevant statistics for overall improvement. Simply
                  put, it is your personal coach. A coach that guides you,
                  motivates you, and educates you, without making it
                  intimidating. Everything is at your pace and convenience.
                  <br /> <br /> Our subject-expert team understands the nuances
                  of staying fit and healthy, especially in this hybrid work
                  model to resolve post-Covid health issues. They work round the
                  clock to help us steer away from the rapidly declining health
                  in India and Western nations and let every individual emerge
                  as a{" "}
                  <span className="text-primary-neonGreen font-bold">
                    WINNER
                  </span>{" "}
                  when it comes to their health.
                  <br />
                  <br /> We are not here for a 400-meter sprint. We are here for
                  a full marathon. And we are determined to take you to the
                  finish line of it, together. Because for us, our priority is
                  to make fitness and health a way of life and not just a part
                  of life for you.
                </p>
              </div>
            )}
            {(selectedSection == "founder-story" || isMobile) && (
              <>
                {isMobile && (
                  <p
                    className={`font-poppins mt-10 cursor-pointer text-white font-bold text-4xl md:text-4xl leading-snug `}
                  >
                    Founder's{" "}
                    <span className="text-primary-neonGreen">Story</span>
                  </p>
                )}
                <p>
                  “While many of us procrastinate the idea of staying fit and
                  healthy, I am glad that my own sons are toggling between
                  different sports like Badminton, Cricket, Football and
                  academics quite well. I was already sold on the fact that
                  their academic performance gets better every time they are
                  involved in sports and fitness. I do have enough reasons to
                  believe that exercising helps you in your overall betterment
                  in ALL walks and ALL ages of life, be it academic or
                  corporate. If you closely look at the resumes and chosen
                  crafts of several high achievers across the world, you will
                  find one thing in common - their love and dedication towards
                  holistic health and wellness. I figured out the problem
                  statement of people. It’s the feeling of not being interested
                  in staying healthy and fit. The lack of time to check-in at
                  the gym, the expensive memberships, and more than anything,
                  not feeling pumped up to get up and stretch. In a nutshell,
                  after lingering over this thought for more than 11 years, and
                  having my first hand challenges, I figured out that this is my
                  push factor to jump onto the startup journey in the health and
                  fitness world. A journey of making people healthy and making
                  fitness a priority for every individual. Making it a lifestyle
                  habit for everyone, but at their pace and comfort without
                  making it expensive, boring and meh.”
                </p>
              </>
            )}
            {(selectedSection == "our-team" || isMobile) && (
              <div>
                {isMobile && (
                  <p
                    className={`font-poppins cursor-pointer mt-10 text-white font-bold text-4xl md:text-4xl leading-snug `}
                  >
                    Our <span className="text-primary-neonGreen">Team</span>
                  </p>
                )}
                <p className="font-bold">Amit Gupta</p>
                <p>Founder and CEO</p>
                <br />
                <p>
                  Amit Gupta, is a Passionate, Result-driven business leader
                  bringing 22 years of experience as an accomplished CXO to the
                  table. A visionary executive with success implementing plans
                  to meet current and future needs and a proven record of
                  outpacing performance goals. Amit has a Solid Media,
                  Healthcare and Consultancy background with in-depth knowledge
                  on matters of Finance, Business and strategy. At getActyv,
                  Amit holds the position of a Founder. He works across
                  functions of Marketing, Product, Talent and Investor
                  relations. Amit himself believes and likes to keep a Motivated
                  team, oriented to develop a world class product, and ensuring
                  highest standards of integrity in action with superlative
                  customer service.
                </p>
                <br />
                <br />
                <p className="font-bold">Raji Viswanadhan</p>
                <p>Chief People Officer</p>
                <br />
                <p>
                  Raji Viswanadhan, was involved in an executive capacity in
                  several organizations both in USA and India. She had a
                  versatlie experience in HR management, sales, marketing,
                  teaching and training. At getactyv, Raji holds the position of
                  Chief People Officer. She works across levels, ushering and
                  developing individual responsibility, transparency, and a
                  culture of ownership. Her role includes building a sustainable
                  and competitive workspace by selecting top talent with
                  distinct capabilities and skills.
                </p>
                <br />
                <br />
                <p className="font-bold">Ram Kiran Ballan</p>
                <p>Chief Product Officer</p>
                <br />
                <p>
                  Ram’s journey of over 20 years has been in the field of Health
                  & Fitness for Adults & Young population. He witnessed the
                  metamorphosis of fitness from traditional bodybuilding methods
                  to endurance activities like marathons, and triathlons and
                  performance sports like soccer, basketball, and badminton with
                  the emergence of understanding biomechanics. With increasing
                  specialization, structured and measured performances, and
                  in-depth training protocols, a deep understanding of human
                  anatomy and movement science is the vantage point, Ram
                  analyzes the evolutionary curve of health & fitness. Ram
                  believes that the ideal world of fitness and health would be
                  to combine the basic science of biomechanics of exercise with
                  the technological advancement in the sporting and fitness
                  industry.
                </p>
                <br />
                <br />
                {/* <p className="font-bold">Prajwal V Athreya</p>
                <p>Lead Artificial Intelligence Engineer</p>
                <br />
                <p>
                  Prajwal plays a pivotal role in shaping the development of the
                  organization's products, with a particular focus on building
                  advanced and scalable deep learning systems using cutting-edge
                  AI technologies. His exceptional attention to detail,
                  strategic mindset, and commitment to staying at the forefront
                  of the latest advancements in the field make him a valuable
                  asset to the product team. Prajwal collaborates closely with
                  cross-functional teams, including engineering, design,
                  marketing, and sales, to ensure that the organization's
                  product offerings align with its overall strategy and meet the
                  evolving needs of its customers.
                </p> */}
                {/* <br />
                <br />
                <p className="font-bold">Amit Gupta</p>
                <p>Chief Product Officer</p>
                <br />
                <p>
                  Ram’s journey of over 20 years has been in the field of Health
                  & Fitness for Adults & Young population. He witnessed the
                  metamorphosis of fitness from traditional bodybuilding methods
                  to endurance activities like marathons, and triathlons and
                  performance sports like soccer, basketball, and badminton with
                  the emergence of understanding biomechanics. With increasing
                  specialization, structured and measured performances, and
                  in-depth training protocols, a deep understanding of human
                  anatomy and movement science is the vantage point, Ram
                  analyzes the evolutionary curve of health & fitness. Ram
                  believes that the ideal world of fitness and health would be
                  to combine the basic science of biomechanics of exercise with
                  the technological advancement in the sporting and fitness
                  industry.
                </p> */}
              </div>
            )}
          </div>
        </div>
      </div>
      <HealthyLife
        openAuth={() => {
          setShowAuth(true);
        }}
      />
      <StartFreeTrail
        openAuth={() => {
          setShowAuth(true);
        }}
      />
    </div>
  );
}
